import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import '@shopify/polaris/build/esm/styles.css';
import reportWebVitals from './reportWebVitals';
import enTranslations from '@shopify/polaris/locales/en.json';
import { AppProvider } from '@shopify/polaris';
import { Provider as AppBridgeProvider } from '@shopify/app-bridge-react';
import type { AppConfigV2 } from '@shopify/app-bridge/client';
import Firebase, { FirebaseContext } from './contexts/firebase';

import { AuthError } from './components/Errors/AuthError';
import { ToastProvider, ToastElement } from './contexts/ToastContext';
import { ModalProvider, ModalElement } from './contexts/ModalContext';

const isInstallationNeeded: boolean = window.top === window.self;

const urlParams = new URLSearchParams(window.location.search);
const host = urlParams.get('host');
const shop = urlParams.get('shop');

if (isInstallationNeeded) {
  window.location.replace(
    process.env.REACT_APP_CLOUD_FUNCTIONS_URI + '/ShopifyApp' + window.location.search,
  );
} else {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  if (
    typeof process.env.REACT_APP_SHOPIFY_API_KEY !== "string" || 
    typeof host !== "string" || 
    typeof shop !== "string"
  ) {
    root.render(
      <React.StrictMode>
        <AppProvider i18n={enTranslations}>
          <AuthError />
        </AppProvider>
      </React.StrictMode>
    );
  } else {
    // set config
    const appBridgeConfig: AppConfigV2 = {
      apiKey: process.env.REACT_APP_SHOPIFY_API_KEY,
      host,
    };

    // render app bridge
    root.render(
      <React.StrictMode>
        <AppProvider i18n={enTranslations}>
          <AppBridgeProvider config={appBridgeConfig}>
            <FirebaseContext.Provider value={new Firebase(false)}>
              <ToastProvider>
                <ModalProvider>
                  <ToastElement />
                  <ModalElement />
                  <App shop={shop} />
                </ModalProvider>
              </ToastProvider>
            </FirebaseContext.Provider>
          </AppBridgeProvider>
        </AppProvider>
      </React.StrictMode>
    );  
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
